import PrimaryGroups from './PrimaryGroups';

export { type PrimaryGroupsProps } from './PrimaryGroups';
export default PrimaryGroups;
